export default () => ({
  trigger: {
    name: 'segment_navigation.close_menu',
    params: {},
  },
  config: {
    event: {
      name: 'close',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
